import React from 'react'
import _ from 'underscore'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'

class ToggleOptions extends React.Component {

  render() {
    const { options, pressed } = this.props

    return (
      <ToggleGroup
        type="single"
        variant="outline"
        size="sm"
        spacing={1}
        className="flex-wrap"
        value={pressed != null ? String(pressed) : ''}
      >
        {_.map(options, (option) => (
          <ToggleGroupItem
            key={option.value}
            value={String(option.value)}
            className="aria-pressed:border-foreground aria-pressed:bg-foreground aria-pressed:text-background aria-pressed:hover:bg-foreground aria-pressed:hover:text-background data-[state=on]:border-foreground data-[state=on]:bg-foreground data-[state=on]:text-background"
            onClick={() => this.props.onClick(option.value)}
          >
            {option.name}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    )
  }
}

export default ToggleOptions
